import {Receita} from "./Receita";

export class ParamAditivo {
  idePac: number;
  comentario: string;
  tipoPessoaFisicaJuridica: string
  cnpjCpf: string;
  cnaeComprador: string;
  caractCapitalSocial: number;
  indAtividadeDecreto: boolean;
  porteEmpresa: string;
  rob: Receita;
  cnpjLiderGrupo: string;
  robGrupo: Receita;
  codMunicipioInstalacao: number;
  cnaeInvestimento: string;
  cnpjInvestimento: string;
}
